__turbopack_context__.v({
  "airlineIcon": "n9e4Qa_airlineIcon",
  "airlineWrapper": "n9e4Qa_airlineWrapper",
  "containerBetweenTracks": "n9e4Qa_containerBetweenTracks",
  "featuresWrapper": "n9e4Qa_featuresWrapper",
  "flightArrivalDate": "n9e4Qa_flightArrivalDate",
  "flightContent": "n9e4Qa_flightContent",
  "flightContentHeading": "n9e4Qa_flightContentHeading",
  "flightContentMain": "n9e4Qa_flightContentMain",
  "flightDepartureDate": "n9e4Qa_flightDepartureDate",
  "flightDetails": "n9e4Qa_flightDetails",
  "flightDuration": "n9e4Qa_flightDuration",
  "flightDurationValue": "n9e4Qa_flightDurationValue",
  "flightDurationWrapper": "n9e4Qa_flightDurationWrapper",
  "flightOutboundInbound": "n9e4Qa_flightOutboundInbound",
  "icon": "n9e4Qa_icon",
  "infoBlock": "n9e4Qa_infoBlock",
  "infoItem": "n9e4Qa_infoItem",
  "listItemRoot": "n9e4Qa_listItemRoot" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "listItemRootSelected": "n9e4Qa_listItemRootSelected",
  "noFlightDurationText": "n9e4Qa_noFlightDurationText",
  "priceWrapper": "n9e4Qa_priceWrapper",
  "priceWrapperSelected": "n9e4Qa_priceWrapperSelected",
  "remark": "n9e4Qa_remark",
  "selectedLabel": "n9e4Qa_selectedLabel",
  "tag": "n9e4Qa_tag",
  "textBetweenTracks": "n9e4Qa_textBetweenTracks",
  "track": "n9e4Qa_track",
});
